/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  landlords: [],
  limit: 5,
};

const getters = {
  landlords: state => state.landlords,
  limit: state => state.limit,
};

const actions = {
  fetch({ commit }, payload) {
    const limit = `&limit=${state.limit}`;
    let keyword = '';
    const path = `superadmin/${payload.user.data.id}`;
    if (payload.keyword) {
      keyword = `&q=${payload.keyword.replace(/[^a-zA-Z0-9]/g, '')}`;
    }
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/landlords/list?${keyword}${limit}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch landlords');
      });
  },
  list({ commit }, payload) {
    const path = `superadmin/${payload.user.data.id}`;
    // TODO: filter, limit has to be like this for now
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/landlords/list?limit=100`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch landlords');
      });
  },
  filter({ commit }, payload) {
    const limit = `&limit=${state.limit}`;
    Vue.http.get(`${process.env.BACKEND_API_URL}api/filter/landlord/${payload.user.data.landlord_id}/partners/?keyword=${payload.keyword.trim()}${limit}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response.data);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, landlords) {
    state.landlords = landlords.data;
  },
  [mTypes.EDIT_DATA](state, updatedLandlord) {
    const index = state.landlords.items.findIndex(obj => obj.id === updatedLandlord.id);
    if (index !== -1) {
      state.landlords.items[index].name = updatedLandlord.name;
      state.landlords.items[index].address = updatedLandlord.address;
    } else {
      state.landlords.items.unshift(updatedLandlord);
      state.landlords.total += 1;
    }
  },
  [mTypes.DATA_FETCHED](state, landlords) {
    state.landlords = landlords.data;
  },
  [mTypes.SET_LIMIT](state, limit) {
    state.limit = limit;
  },
  [mTypes.REMOVE_DATA](state, landlordId) {
    const index = state.landlords.items.findIndex(obj => obj.id === landlordId);
    state.landlords.items.splice(index, 1);
    state.landlords.total -= 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/landlords.js